import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Form, Input, Checkbox, Select, List, Button, notification } from 'antd';
import axios from 'axios';
import * as _ from 'lodash';

const { TextArea } = Input;

const SettingsForm = (props) => {

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [starting, setStarting] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    axios.post('/api/workflow/GetApprovers', _.map(props.selectedItems, 'ID')).then((res) => {
      setUsers(res.data);
      setLoading(false);
    }).catch(error => { alert('Error getting user list!') })
  }, [props.selectedItems])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  const handleSubmit = values => {

    setStarting(true);
    setDisabled(true);

    const postData = {
      objectIds: _.map(props.selectedItems, 'ID'),
      ...values,
      message: _.escape(values.message)
    }

    axios.post('/api/workflow/StartQuickApprovalWorkflow', postData).then((res) => {
      setStarting(false);
      setDisabled(false);
      props.hideModal();
      props.angularScope.$broadcast('reloadGrid');

      notification.success({ message: 'Workflow started!' });
    })
    .catch(error => {
      setStarting(false);
      setDisabled(false);
      alert('Error starting workflow!')
    })
  }

  const handleChange = (value) => {
    if(value !== '') {
      setDisabled(false);
    }
  }

  return (
    <Container>
      <Form
        form={form}
        {...formItemLayout}
        onFinish={handleSubmit}
        labelAlign="left"
      >
        <Form.Item label="Assign approver" name="approver" rules={[{required: true, message: 'Approver required!'}]}>
            <Select
              showSearch
              loading={loading}
              onChange={handleChange}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {users.map(user => (
                <Select.Option key={user.userId} value={user.userId}>{user.fullName}</Select.Option>
              ))}
            </Select>
        </Form.Item>
        <Form.Item label="Files">
          <List
            size="small"
            style={{ maxHeight: '115px', overflow: 'hidden', overflowY: 'auto' }}
            bordered
            dataSource={props.selectedItems}
            renderItem={item => (
              <List.Item key={item.ID} title={`${item.Name}.${item.Type}`}>
                <div className={`file-icon-small files-small-${item.Type}`}></div>
                <FileName>{`${item.Name}.${item.Type}`}</FileName>
              </List.Item>
            )}
          />
        </Form.Item>
        <Form.Item label="Message to recipient" name="message">
          <TextArea rows={5} />
        </Form.Item>
        <Form.Item style={{ paddingTop: '10px' }} name="convertToPDF" valuePropName="checked">
            <Checkbox>Convert to PDF after approval</Checkbox>
        </Form.Item>

        <Form.Item
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
          }}
          style={{ marginTop: '25px' }}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ float: 'right', marginLeft: '10px' }}
            disabled={disabled}
            loading={starting}>
            Start Workflow
          </Button>
          <Button
            style={{ float: 'right' }}
            onClick={props.hideModal}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Container>
  );
};

const FileName = styled.div`
  margin-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
  flex: auto;
`

const Container = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`
const mapStateToProps = state => ({ toasts: state.toasts });

export default connect(mapStateToProps)(SettingsForm);